import { useCallback } from 'react';

import { useTheme } from '@mui/material/styles';

import { Box } from '@vk-hr-tek/ui/Box';
import { CircularProgress } from '@vk-hr-tek/ui/CircularProgress';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { useInject } from '@vk-hr-tek/core/ioc';
import { Icon } from '@vk-hr-tek/ui/Icon';

import {
  AuthSourceLogo,
  AdditionalAuthButton,
  Button,
  Page,
  LegalLinks,
} from '../../../segments';
import { useGetAuthInstance } from '../../../hooks';
import { AuthConfigService } from '../../../services';

export const Login = () => {
  const config = useInject(AuthConfigService);
  const isDesktop = useIsDesktop();
  const theme = useTheme();
  const authInstance = useGetAuthInstance();

  const oauth2AutoSubmit =
    window.REACT_APP_VKHRTEK_OAUTH2_AUTO_SUBMIT.toString() === 'true';

  const formRef = useCallback(
    (element: HTMLFormElement) => {
      if (oauth2AutoSubmit && element) {
        element.submit();
      }
    },
    [oauth2AutoSubmit],
  );

  const textForButton = 'Войти через Госуслуги';

  return (
    <Page title="" theme="oauth2">
      <form
        action={`${config.getApiUrl()}/oauth2/auth_form/init`}
        method="POST"
        ref={formRef}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <AuthSourceLogo variant={isDesktop ? '80' : '72'} />
          <Box
            mt={{ xs: '32', md: '40' }}
            mb={{ xs: '32', md: '32' }}
            gap="16"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Typography variant={isDesktop ? 'h4' : 'h5'} align="center">
              Добро пожаловать!
            </Typography>
            <Typography variant={isDesktop ? 'body1' : 'body3'} align="center">
              Это сервис кадрового электронного документооборота (КЭДО)
            </Typography>
          </Box>
          <input type="hidden" value="false" name="phone_change" />
          <input type="hidden" value="esia" name="source" />
          <input
            type="hidden"
            value={authInstance.id}
            name="auth_instance_id"
          />
          {oauth2AutoSubmit ? (
            <CircularProgress size={50} />
          ) : (
            <Button
              border={`2px solid ${theme.tokens.colors.stroke.primary}`}
              color="#ffffff"
              isEsia
            >
              <Typography variant="h6">
                <Box
                  display="flex"
                  gap="8"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon name="vkhrtek_gosuslugi" size="24" />
                  {textForButton}
                </Box>
              </Typography>
            </Button>
          )}
          <AdditionalAuthButton />
          {!window.REACT_APP_VKHRTEK_HIDE_AUTH_LEGAL_LINKS && (
            <Box mt="16">
              <LegalLinks
                policyConfidentialityLink="policy_confidentiality"
                userAggrementLink="user_agreement"
                buttonText={textForButton}
              />
            </Box>
          )}
        </Box>
      </form>
    </Page>
  );
};
